module.exports = __webpack_public_path__ + "img/lg_ring_r_e_null_null@2x.9d41cbbf.png";